enum Mutations {
  setItems = 'setItems',
}

export default Mutations;
